import React, { useState } from "react";
import './Register.css';
import { registerUser } from "../services/authService";

const Register = () => {
  const [form, setForm] = useState({
    email: "",
    first_name: "",
    last_name: "",
    role: "exam_manager", // Default to exam_manager
    phone: "",
    password: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await registerUser(form);
      setSuccess(result.message);
      setForm({
        email: "",
        first_name: "",
        last_name: "",
        role: "exam_manager",
        phone: "",
        password: "",
      });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="register-container">
      <h3>Create Account</h3>
      <p>Please fill in the details below</p>

      <form className="register-form" onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="first_name"
          placeholder="First Name"
          value={form.first_name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="last_name"
          placeholder="Last Name"
          value={form.last_name}
          onChange={handleChange}
          required
        />
        
        <input
          type="tel"
          name="phone"
          placeholder="Phone"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />

        <button type="submit">Sign Up</button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}
    </div>
  );
};

export default Register;